import { ReactElement, useState } from "react";
import { StoreMethodMetaData } from "../constants/methods";
import { useCedeStore } from "../hooks/useCedeStore";
import { ActionCard } from "./form/ActionCard";
import { displayInstallationModal } from "@cedelabs/providers/src";
// import { CedeOnboardingModal } from "@cedelabs/widgets/src";
import { Box, useTheme, Typography } from "@mui/material";

export type SuiteSectionProps = {
  title: string;
  methods: StoreMethodMetaData[];
  startSlot?: ReactElement;
};

export const SuiteSection = ({ title, methods, startSlot }: SuiteSectionProps) => {
  const theme = useTheme();
  const provider = useCedeStore((state) => state.provider);
  const [openModal, setOpenModal] = useState(false);
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: theme.custom.smallGutterMargin,
        marginBottom: theme.custom.bigGutterMargin,
      }}
    >
      {/* <CedeOnboardingModal open={openModal} exit={() => setOpenModal(false)} /> */}
      <Typography
        sx={{
          fontSize: "25px",
          lineHeight: "40px",
          fontWeight: "600",
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: `repeat(auto-fill, minmax(350px, 1fr))`,
          gap: theme.custom.bigGutterMargin,
        }}
      >
        {startSlot}
        {methods.map((method) => (
          <ActionCard
            key={method.methodName}
            id={method.methodName}
            method={method}
            req={async (params) => {
              if (provider) {
                return await provider.request({ method: method.methodName, params });
              } else {
                // setOpenModal(true);
                displayInstallationModal({
                  readOnlyOnboarding: params?.readOnlyOnboarding,
                  callbackUrl: params?.callbackUrl ?? "https://send.cede.store",
                });
                return "Opening Cede installation modal...";
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
